import React from 'react';

import styles from './WhatToBring.module.scss';

import GenericCard from '../../components/GenericCard/GenericCard';
import BackButtonHeader from '../../components/back-button-header/BackButtonHeader';

const itemsToBring = [
  {
    title: 'WATER & SNACKS',
    icon: 'WATER',
    description: 'Make sure you stay fed and hydrated',
  },
  {
    title: 'CASH',
    icon: 'MONEY',
    description: 'Bring enough money in small bills just in case',
  },
  {
    title: 'YOUR ID',
    icon: 'DNI',
    description: 'Bring some form of ID and keep it on your body',
  },
  {
    title: 'EMERGENCY CONTACT',
    icon: 'BELL',
    description: 'Make a notecard with these contacts on it',
  },
  {
    title: 'MASK',
    icon: 'MASK',
    description:
      'To protect against germs and possible crowd control chemicals',
  },
  {
    title: 'GLASSES/GOGGLES',
    icon: 'GLASSES',
    description: 'To protect eyes from possible crowd control chemicals',
  },
];

const WhatToBring = () => {
  return (
    <>
      <BackButtonHeader />
      <div className={styles.contentWrapper}>
        <div className={styles.upperLine} />
        <h1>What to bring to a peaceful protest</h1>
        <p>
          The gear you should bring when excercising your Constitutional right
          to peaceably assemble.
        </p>
        <div className={styles.items}>
          {!!itemsToBring &&
            itemsToBring.map((item) => <GenericCard item={item} />)}
        </div>
      </div>
    </>
  );
};

export default WhatToBring;
